module.exports = __webpack_public_path__ + "img/logo-2x.3bbd849a.png";